import { BaseAPI } from '@/api/base.api'
import { AxiosObservable } from 'axios-observable';

export class VehicleAPI extends BaseAPI<any> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_app/v1`;
  }

  public list(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/vehicles`);
  }

  public listForExclusion(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/vehicles/exclusion`);
  }

  public listForInclusion(plate: string): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/vehicles/inclusion?plate=${plate}`);
  }

  public listOperationAreas(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/vehicles/operation_areas`);
  }

  public listProducers(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/vehicles/list_producers`);
  }

  public bodyModels(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/vehicles/body_models`);
  }
}
